const Bucket = () => import('@/pages/system/attachment/bucket')

const CreateBucket = () => import('@/pages/system/attachment/bucket/create')

export default {
  path: 'bucket',
  meta: {
    label: 'bucket',
    auth: 'bucket'
  },
  component: {
    name: 'Bucket',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemBucketReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Bucket
    },
    {
      name: 'SystemCreateBucket',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateBucket
    }
  ]
}
